// Menú de Pizzería Estilo Gali
// Prices in MXN.

// ─────────────────────────────────────────────────────────────────────
// COMBOS ESPECIALES (los que ya tenías antes)
// ─────────────────────────────────────────────────────────────────────
export const MENU_ITEMS = [
  {
    id: "pizza-cuadrada-4-sabores",
    name: "Pizza Cuadrada · 4 Sabores",
    description:
      "Nuestra pizza estrella. 20 rebanadas y 4 sabores a elegir para compartir. Ideal para la familia o los amigos.",
    price: 290,
    tag: "Para compartir",
    image:
      "https://customer-assets.emergentagent.com/job_pizzeria-gali/artifacts/5rl02sza_7224c771-6a08-42ed-bd23-273cf2cc0f2f.jpg",
  },
  {
    id: "combo-familiar",
    name: "Combo Familiar Estilo Gali",
    description:
      "2 hamburguesas + papas a la francesa + alitas + pizza hawaiana. El combo más completo para acabar con el hambre.",
    price: 390,
    tag: "Combo XL",
    image:
      "https://customer-assets.emergentagent.com/job_pizzeria-gali/artifacts/feznpbet_WhatsApp%20Image%202026-06-07%20at%2010.47.09%20PM.jpeg",
  },
  {
    id: "combo-doble-gali",
    name: "Combo Doble Gali",
    description:
      "Hamburguesa + 2 hot dogs con pico de gallo + papas a la francesa. Servido con chile toreado y salsas de la casa.",
    price: 340,
    tag: "Combo",
    image:
      "https://customer-assets.emergentagent.com/job_pizzeria-gali/artifacts/khw2etii_WhatsApp%20Image%202026-06-07%20at%2010.47.41%20PM%20%281%29.jpeg",
  },
  {
    id: "combo-hawaiano",
    name: "Combo Hawaiano",
    description:
      "Hamburguesa hawaiana + 2 hot dogs + papas a la francesa. Dulce, salado y crujiente en una sola charola.",
    price: 200,
    tag: "Combo",
    image:
      "https://customer-assets.emergentagent.com/job_pizzeria-gali/artifacts/4wkoqo29_WhatsApp%20Image%202026-06-07%20at%2010.43.07%20PM.jpeg",
  },
  {
    id: "super-hamburguesa",
    name: "Súper Hamburguesa",
    description:
      "Doble carne, doble queso, tocino crujiente y pan con ajonjolí. Servida con papas a la francesa.",
    price: 170,
    tag: "C/u",
    image:
      "https://customer-assets.emergentagent.com/job_pizzeria-gali/artifacts/4jeczxwy_WhatsApp%20Image%202026-06-07%20at%2010.48.43%20PM.jpeg",
  },
  {
    id: "combo-3-hamburguesas",
    name: "Combo 3 Súper Hamburguesas",
    description:
      "3 hamburguesas sencillas acompañadas de papas a la francesa, queso cheddar y tocino.",
    price: 330,
    tag: "Para compartir",
    image:
      "https://customer-assets.emergentagent.com/job_pizzeria-gali/artifacts/exzhaawk_WhatsApp%20Image%202026-06-07%20at%2010.49.53%20PM.jpeg",
  },
  {
    id: "botana-variada",
    name: "Botana Variada",
    description:
      "Nuggets, dedos de queso, papas onduladas y pizza de pepperoni. La botana perfecta para picar entre varios.",
    price: 410,
    tag: "Botana",
    image:
      "https://customer-assets.emergentagent.com/job_pizzeria-gali/artifacts/q0h58b71_907609d3-7337-4c3a-b237-d4d107c0782c%20%281%29.jpg",
  },
  {
    id: "combo-fiesta-gali",
    name: "Combo Fiesta Gali",
    description:
      "El mega combo para reunión: hamburguesas, alitas BBQ y búfalo, papas a la francesa, aros de cebolla y dedos de queso con salsas.",
    price: 780,
    tag: "Para fiesta",
    image:
      "https://customer-assets.emergentagent.com/job_pizzeria-gali/artifacts/cme8vnlk_WhatsApp%20Image%202026-06-07%20at%2010.49.32%20PM.jpeg",
  },
  {
    id: "pizza-cuadrada-2-sabores",
    name: "Pizza Cuadrada · 2 Sabores",
    description:
      "20 rebanadas de pizza cuadrada con 2 sabores a elegir. Ideal para compartir con la familia sin romper la alcancía.",
    price: 260,
    tag: "20 rebanadas",
    image:
      "https://customer-assets.emergentagent.com/job_pizzeria-gali/artifacts/ojyt12jf_bab94869-87ee-489e-aaa9-ba56e56512a1.jpg",
  },
  {
    id: "combo-pareja",
    name: "Combo Pareja",
    description:
      "Pizza personal de pepperoni + hamburguesa + alitas + papas a la francesa. La opción perfecta para dos.",
    price: 270,
    tag: "Para 2",
    image:
      "https://customer-assets.emergentagent.com/job_pizzeria-gali/artifacts/y5cv88uc_09431632-a7db-404f-8756-606d9cc72b23.jpg",
  },
  {
    id: "burritos-pastor",
    name: "Burritos de Pastor",
    description:
      "Dos piezas de burrito de pastor a la plancha con pico de gallo, aguacate, rábano y limón. Con salsa de la casa.",
    price: 130,
    tag: "2 piezas",
    image:
      "https://customer-assets.emergentagent.com/job_pizzeria-gali/artifacts/iigwobag_0794474e-aad9-4bb1-a412-7558f6da0d8d.jpg",
  },
  {
    id: "hamburguesa-junior-combo",
    name: "Hamburguesa Junior",
    description:
      "Nuestra hamburguesa con carne a la parrilla, queso amarillo, pepinillos, tomate, lechuga y salsa de la casa en pan con ajonjolí.",
    price: 130,
    tag: "Clásica",
    image:
      "https://customer-assets.emergentagent.com/job_pizzeria-gali/artifacts/g0irwed8_27e155ea-1ac8-4f92-8175-40a22521d54e.jpg",
  },
  {
    id: "alitas-al-mango",
    name: "Alitas al Mango",
    description:
      "Piezas de pollo empanizado bañadas en nuestra salsa cremosa de mango-habanero. Dulce con un toque picoso.",
    price: 200,
    tag: "Especial",
    image:
      "https://customer-assets.emergentagent.com/job_pizzeria-gali/artifacts/fujia48i_WhatsApp%20Image%202026-06-07%20at%2010.52.12%20PM.jpeg",
  },
  {
    id: "combo-hamburguesa-hotdogs",
    name: "Combo Hamburguesa + 2 Hot Dogs",
    description:
      "1 hamburguesa con 2 hot dogs, papas a la francesa y aderezos de la casa.",
    price: 200,
    tag: "Combo",
    image:
      "https://customer-assets.emergentagent.com/job_pizzeria-gali/artifacts/gltad597_WhatsApp%20Image%202026-06-07%20at%2010.53.07%20PM.jpeg",
  },
  {
    id: "combo-doble-hotdog",
    name: "Combo Doble Hot Dog",
    description:
      "Dos hot dogs con pico de gallo + hamburguesa con lechuga y tomate + papas a la francesa y aderezo de la casa.",
    price: 260,
    tag: "Combo",
    image:
      "https://customer-assets.emergentagent.com/job_pizzeria-gali/artifacts/ebr0t35u_WhatsApp%20Image%202026-06-07%20at%2010.52.34%20PM.jpeg",
  },
  {
    id: "ensalada-gali",
    name: "Ensalada Estilo Gali",
    description:
      "Lechuga fresca, pollo empanizado, granos de elote, tomate y cebolla morada con aderezo a elegir.",
    price: 150,
    tag: "Fresca",
    image:
      "https://customer-assets.emergentagent.com/job_pizzeria-gali/artifacts/eu4xcz0i_434a35e0-b553-4c04-9407-4fc412bad697.jpg",
  },
  {
    id: "combo-pizza-chica-arizona",
    name: "Combo Pizza Chica + Arizona",
    description:
      "Pizza chica de pepperoni recién horneada acompañada de una bebida Arizona de tu sabor favorito.",
    price: 150,
    tag: "Combo bebida",
    image:
      "https://customer-assets.emergentagent.com/job_pizzeria-gali/artifacts/g2a30cgw_a925a4a0-e53e-4756-85b2-a81b6bf46bd0.jpg",
  },
  {
    id: "combo-hamburger",
    name: "Combo Hamburger",
    description:
      "Hamburguesa sencilla con lechuga, tomate y queso, más papas a la francesa y un jugo. El combo económico.",
    price: 160,
    tag: "Combo bebida",
    image:
      "https://customer-assets.emergentagent.com/job_pizzeria-gali/artifacts/nzana2xu_eab20f9c-dc93-49e4-80f3-b6f45d2f0e50.jpg",
  },
  {
    id: "combo-personal",
    name: "¡Combo Personal!",
    description:
      "Pizza personal de 4 rebanadas + porción de papas + refresco de 600 ml.",
    price: 125,
    tag: "Combo",
    image:
      "https://customer-assets.emergentagent.com/job_pizzeria-gali/artifacts/lgdhr35j_WhatsApp%20Image%202026-07-13%20at%2012.48.55%20AM.jpeg",
  },
];

// ─────────────────────────────────────────────────────────────────────
// MENÚ GENERAL (según las 4 imágenes oficiales del local)
// Cada sección incluye la imagen original del menú tal cual, con
// botones para añadir cada producto al carrito.
// ─────────────────────────────────────────────────────────────────────

// Tamaños compartidos por todas las pizzas
export const PIZZA_SIZES = [
  { name: "Personal", price: 80 },
  { name: "Chica", price: 120 },
  { name: "Mediana", price: 160 },
  { name: "Grande", price: 200 },
  { name: "Familiar", price: 260 },
  { name: "Cuadrada", price: 300 },
];

// 8 pizzas — cada una tiene 6 tamaños con precio fijo
const PIZZAS_MENU = [
  {
    id: "gm-pizza-especialidad",
    name: "Especialidad de la Casa",
    description: "Bonelles, Pastor.",
    sizes: PIZZA_SIZES,
  },
  {
    id: "gm-pizza-estilo-gali",
    name: "Estilo Gali",
    description: "Pepperoni, Champiñón, Pimiento, Cebolla, Carne Asada.",
    sizes: PIZZA_SIZES,
  },
  {
    id: "gm-pizza-hawaiana",
    name: "Hawaiana",
    description: "Jamón, Piña.",
    sizes: PIZZA_SIZES,
  },
  {
    id: "gm-pizza-pepperoni",
    name: "Pepperoni",
    description: "Pepperoni.",
    sizes: PIZZA_SIZES,
  },
  {
    id: "gm-pizza-suprema",
    name: "Suprema",
    description:
      "Jamón, Champiñón, Salchicha, Salami, Chorizo, Pimiento, Cebolla.",
    sizes: PIZZA_SIZES,
  },
  {
    id: "gm-pizza-carnes-frias",
    name: "Carnes Frías",
    description: "Pepperoni, Jamón, Salchicha, Tocino, Chorizo.",
    sizes: PIZZA_SIZES,
  },
  {
    id: "gm-pizza-italiana",
    name: "Italiana",
    description: "Jamón, Piña, Champiñón, Pimiento, Tocino.",
    sizes: PIZZA_SIZES,
  },
  {
    id: "gm-pizza-mexicana",
    name: "Mexicana",
    description: "Salchicha, Pimiento, Chorizo, Cebolla.",
    sizes: PIZZA_SIZES,
  },
];

// 8 hamburguesas (todas incluyen papas + coca 355 ml)
const HAMBURGUESAS_MENU = [
  {
    id: "gm-hb-super",
    name: "Superhamburguesa",
    description:
      "Doble carne de res, tocino, queso chédar, cebolla caramelizada.",
    price: 170,
  },
  {
    id: "gm-hb-pollo",
    name: "Pollo",
    description: "Tender, queso y verdura.",
    price: 120,
  },
  {
    id: "gm-hb-sencilla",
    name: "Sencilla",
    description: "Carne de res, queso y verdura.",
    price: 115,
  },
  {
    id: "gm-hb-doble",
    name: "Doble",
    description: "Doble carne de res, queso y verdura.",
    price: 140,
  },
  {
    id: "gm-hb-tasty",
    name: "Tasty Burger",
    description: "Carne de res, tocino, guacamole y verdura.",
    price: 140,
  },
  {
    id: "gm-hb-hawaiana",
    name: "Hawaiana",
    description: "Carne de res, tocino, jamón, piña y verdura.",
    price: 130,
  },
  {
    id: "gm-hb-junior",
    name: "Junior",
    description:
      "Carne de res, tocino, aderezo de la casa, pepinillos y verdura.",
    price: 140,
  },
  {
    id: "gm-hb-suprema",
    name: "Suprema",
    description:
      "Carne de res, tocino, jamón, salchicha, queso gratinado, piña, champiñones y verdura.",
    price: 180,
  },
];

// Snacks
const SNACKS_MENU = [
  {
    id: "gm-burritos-carne-asada",
    name: "Burritos 2 piezas · Carne asada",
    description:
      "Carne asada, guacamole, pico de gallo, queso gratinado.",
    price: 100,
  },
  {
    id: "gm-burritos-pastor",
    name: "Burritos 2 piezas · Pastor",
    description: "Pastor, guacamole, pico de gallo, queso gratinado.",
    price: 110,
  },
  {
    id: "gm-tenders-5pz",
    name: "Tender's 5 piezas",
    description:
      "Trozos de pollo acompañados con aderezo BBQ y porción de papas.",
    price: 170,
  },
  {
    id: "gm-papas-gajo",
    name: "Papas Gajo",
    description: "",
    price: 100,
  },
  {
    id: "gm-papas-francesa",
    name: "Papas a la Francesa",
    description: "",
    price: 80,
  },
  {
    id: "gm-dedos-queso",
    name: "Dedos de Queso",
    description: "Acompañados con papas gajo o a la francesa.",
    price: 100,
  },
  {
    id: "gm-aros-cebolla",
    name: "Aros de Cebolla · 6 piezas",
    description: "Acompañados con dip picoso.",
    price: 80,
  },
  {
    id: "gm-hotdog-tocino",
    name: "Hot Dog con Tocino · 2 piezas",
    description: "Acompañados con papas a la francesa.",
    price: 100,
  },
  {
    id: "gm-sincronizadas",
    name: "Sincronizadas · 3 piezas",
    description: "Acompañadas con papas a la francesa.",
    price: 70,
  },
];

// Alitas boneless (2 tamaños)
const ALITAS_MENU = [
  {
    id: "gm-alitas-8pz",
    name: "Alitas Boneless · 8 piezas",
    description:
      "Salsas: Habanero, BBQ Hot, BBQ, Búfalo, Parmesano, Mango Habanero (temporada).",
    price: 170,
  },
  {
    id: "gm-alitas-10pz",
    name: "Alitas Boneless · 10 piezas",
    description:
      "Salsas: Habanero, BBQ Hot, BBQ, Búfalo, Parmesano, Mango Habanero (temporada).",
    price: 200,
  },
];

// Bebidas
const BEBIDAS_MENU = [
  {
    id: "gm-pinacolada",
    name: "Piña Colada",
    description: "Elige sin o con alcohol.",
    sizes: [
      { name: "Sin alcohol", price: 90 },
      { name: "Con alcohol", price: 100 },
    ],
  },
  {
    id: "gm-frappe",
    name: "Frappe",
    description:
      "Chocolate / Fresa / Vainilla / Ferrero / Gansito / Oreo / Mazapán.",
    price: 90,
  },
  {
    id: "gm-agua-fresca",
    name: "Agua Fresca",
    description: "Preguntar por el sabor en existencia.",
    sizes: [
      { name: "1 LTR", price: 40 },
      { name: "2 LTR", price: 70 },
    ],
  },
  {
    id: "gm-agua-natural-1l",
    name: "Agua Natural 1 LTR",
    description: "",
    price: 30,
  },
  {
    id: "gm-coca-600",
    name: "Coca Cola 600 ml",
    description: "",
    price: 30,
  },
  {
    id: "gm-refresco-600",
    name: "Refresco de sabor 600 ml",
    description: "",
    price: 30,
  },
];

// Cervezas
const CERVEZAS_MENU = [
  {
    id: "gm-cerveza-victoria",
    name: "Cerveza Victoria 1/2",
    description: "",
    price: 30,
  },
  {
    id: "gm-cerveza-corona",
    name: "Cerveza Corona 1/2",
    description: "",
    price: 30,
  },
  {
    id: "gm-cerveza-corona-light",
    name: "Cerveza Corona Light",
    description: "",
    price: 30,
  },
  {
    id: "gm-cerveza-caribes",
    name: "Cerveza Caribes",
    description: "",
    price: 35,
  },
];

// Combo Personal se movió a MENU_ITEMS (sección de combos arriba)

// Secciones del menú general con la imagen oficial de cada apartado
export const MENU_GENERAL_SECTIONS = [
  {
    id: "section-pizzas",
    title: "Pizzas",
    subtitle: "Elige tu sabor y tamaño",
    image:
      "https://customer-assets.emergentagent.com/job_pizzeria-gali/artifacts/o1rcq9uj_WhatsApp%20Image%202026-07-13%20at%201.14.44%20AM%20%281%29.jpeg",
    items: PIZZAS_MENU,
    itemsHaveSizes: true,
    footNote:
      "Personal $80 · Chica $120 · Mediana $160 · Grande $200 · Familiar $260 · Cuadrada $300",
  },
  {
    id: "section-hamburguesas",
    title: "Hamburguesas",
    subtitle: "Todas incluyen papas y coca de 355 ml",
    image:
      "https://customer-assets.emergentagent.com/job_pizzeria-gali/artifacts/iom899a4_WhatsApp%20Image%202026-07-13%20at%201.14.44%20AM.jpeg",
    items: HAMBURGUESAS_MENU,
    itemsHaveSizes: false,
  },
  {
    id: "section-snacks",
    title: "Snacks",
    subtitle: "Botanas y complementos",
    image:
      "https://customer-assets.emergentagent.com/job_pizzeria-gali/artifacts/iefglf2y_WhatsApp%20Image%202026-07-13%20at%201.13.55%20AM.jpeg",
    items: SNACKS_MENU,
    itemsHaveSizes: false,
  },
  {
    id: "section-alitas",
    title: "Alitas Boneless",
    subtitle: "Elige tu salsa favorita",
    image:
      "https://customer-assets.emergentagent.com/job_pizzeria-gali/artifacts/iefglf2y_WhatsApp%20Image%202026-07-13%20at%201.13.55%20AM.jpeg",
    items: ALITAS_MENU,
    itemsHaveSizes: false,
    hideImage: true,
  },
  {
    id: "section-bebidas",
    title: "Bebidas",
    subtitle: "Aguas, refrescos y frappés",
    image:
      "https://customer-assets.emergentagent.com/job_pizzeria-gali/artifacts/f5ya9fk9_WhatsApp%20Image%202026-07-13%20at%201.14.44%20AM%20%282%29.jpeg",
    items: BEBIDAS_MENU,
    itemsHaveSizes: false,
  },
  {
    id: "section-cervezas",
    title: "Cervezas",
    subtitle: "Fría y bien servida",
    image:
      "https://customer-assets.emergentagent.com/job_pizzeria-gali/artifacts/f5ya9fk9_WhatsApp%20Image%202026-07-13%20at%201.14.44%20AM%20%282%29.jpeg",
    items: CERVEZAS_MENU,
    itemsHaveSizes: false,
    hideImage: true,
  },
];

// wa.me funciona en WhatsApp móvil, WhatsApp Desktop y WhatsApp Web (detecta plataforma)
export const WHATSAPP_NUMBER = "+52 742 117 7698";
export const WHATSAPP_LINK =
  "https://wa.me/527421177698?text=" +
  encodeURIComponent("¡Hola Estilo Gali! Quisiera hacer un pedido 🍕");

export const CONTACT = {
  whatsapp: WHATSAPP_NUMBER,
  whatsappLink: WHATSAPP_LINK,
  hours: "Lunes a Domingo · 2:00 PM – 11:00 PM",
  hoursShort: "2:00 PM – 11:00 PM",
  deliveryZone:
    "Envíos a domicilio desde el 20 hasta Tetitlán",
};

// Assets locales (subidos por el cliente)
export const ASSETS = {
  logo:
    "https://customer-assets.emergentagent.com/job_pizzeria-gali/artifacts/glk7mtbp_IMG-20260606-WA0093.jpg",
  storefront:
    "https://customer-assets.emergentagent.com/job_pizzeria-gali/artifacts/00c2r374_IMG-20260607-WA0083.jpg",
  locationQr:
    "https://customer-assets.emergentagent.com/job_pizzeria-gali/artifacts/l6crzrtd_IMG-20260606-WA0106.jpg",
};
